module.exports = new __parcel__URL__("Javascript.ef2353d0.svg").toString();